import { render, staticRenderFns } from "./PresentationTab.vue?vue&type=template&id=5d1190f6&"
import script from "./PresentationTab.vue?vue&type=script&lang=js&"
export * from "./PresentationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports